import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';

const useIsGuest = () => {
  const history = useHistory();

  useEffect(() => {
    let decode = '';
    if (Cookies.get('refresh_token')) {
      decode = jwt_decode(Cookies.get('refresh_token'));
      if (Date.now() / 1000 > decode.exp) {
      } else {
        history.push('/meetings');
        window.location.reload(false);
      }
    } else {
    }
  }, [history]);
  return null;
};

export default useIsGuest;
